/**
 * @file コンポーネント：フル動画ページ編集モーダル執刀医権限ユーザーリスト ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalEditSurgeonUserlist = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    /**
     * 執刀医権限編集フォーム生成
     */
    // 選択済みリストを生成
    const [listSelected, setListSelected] = useState([]); // 選択済みリスト
    useEffect(() => {
        setListSelected(props.list);
    }, [props.list]);
    const [listSelectedId, setListSelectedId] = useState([]); // 選択済みリストのIDのみ抽出
    useEffect(() => {
        // IDのみ抽出
        const resultListSelectedId = listSelected.map((item) => {
            return item.id;
        });
        setListSelectedId(resultListSelectedId);
        // 執刀医権限ユーザーリストを更新
        props.setSurgeonUserList(listSelected);
    }, [listSelected]);
    // ページングの切り替え毎に再生成
    const [listUser, setListUser] = useState([]); // ユーザーリスト
    const [currentPage, setCurrentPage] = useState(1); // ページングの現在のページ
    const [paginationlist, setPaginationlist] = useState([]); // ページングリスト
    // ユーザーリストを生成
    useEffect(() => {
        const tempListUser = [];
        for (let i = currentPage * 10 - 10; i < currentPage * 10; i++) {
            const data: {
                id: number;
                name: string;
                selected: boolean;
            } = window.dataUserList[i];
            if (data !== undefined) {
                data.selected = listSelectedId.indexOf(data.id) !== -1;
                tempListUser.push(window.dataUserList[i]);
            } else {
                tempListUser.push({ id: null, name: null, selected: false });
            }
        }
        setListUser(tempListUser);
    }, [listSelectedId, currentPage]);
    // ページングリストを生成
    useEffect(() => {
        const tempPaginationlist = [];
        for (let i = 0; i < Math.ceil(window.dataUserList.length / 10); i++) {
            const item = {
                href: "#",
                isCurrent: i + 1 === currentPage ? true : false,
                onClick: (e) => {
                    e.preventDefault();
                    setCurrentPage(i + 1);
                },
            };
            tempPaginationlist.push(item);
        }
        setPaginationlist(tempPaginationlist);
    }, [currentPage]);

    /**
     * クリック時の処理
     */
    // 追加ボタン
    const fnOnClickAdd = (e, id, name) => {
        e.preventDefault();
        const api = "/api/SurgeonRoles/add";
        const options = {
            body: JSON.stringify({
                operationId: window.atob(props.operationId),
                userId: id,
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "POST",
        };
        fetch(api, options).then((response) => {
            if (response.url.indexOf(api) === -1) {
                alert(localized["ErrorMessage.SessionExpiredDescription"]);
            } else if (response.status === 200) {
                setListSelected([...listSelected, { id, name }]);
            }
        });
    };
    // 削除ボタン
    const fnOnClickDelete = (e, id) => {
        e.preventDefault();
        const api = "/api/SurgeonRoles/delete";
        const options = {
            body: JSON.stringify({
                operationId: window.atob(props.operationId),
                userId: id,
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "POST",
        };
        fetch(api, options).then((response) => {
            if (response.url.indexOf(api) === -1) {
                alert(localized["ErrorMessage.SessionExpiredDescription"]);
            } else if (response.status === 200) {
                setListSelected(listSelected.filter((item) => item.id !== id));
            }
        });
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnClickAdd={fnOnClickAdd}
            fnOnClickDelete={fnOnClickDelete}
            listSelected={listSelected}
            listUser={listUser}
            paginationlist={paginationlist}
        />
    );
};
